import {
  configureStore,
  combineReducers,
  applyMiddleware,
} from "@reduxjs/toolkit";

import progressMiddleware from "./middleware/progress.middleware";

import appSlice from "./slices/app-slice";
import authSlice from "./slices/auth-slice";
import rolesSlice from "./slices/roles-slice";
import permissionsSlice from "./slices/permissions-slice";
import usersSlice from "./slices/users-slice";
import companiesSlice from "./slices/companies-slice";
import leadsSlice from "./slices/leads-slice";
import activitylogsSlice from "./slices/activitylogs-slice";
import settingsSlice from "./slices/settings-slice";
import dealsSlice from "./slices/deals-slice";
import announcementSlice from "./slices/announcement-slice";
import banksSlice from "./slices/bank-slice";
import clientsSlice from "./slices/client-slice";
import bankProductsSlice from "./slices/bankproducts-slice";
import bankUpdatesSlice from "./slices/bankupdates-slice";
import eiborSLice from "./slices/eibor-slice";
import feeProposalSLice from "./slices/proposal-fee-slice";
import bankRates from "./slices/bank-rates-slice";
import requiredDocsProposalSLice from "./slices/proposal-required-doc-slice";
import proposalSlice from "./slices/proposal-slice";

const reducer = combineReducers({
  app: appSlice.reducer,
  auth: authSlice.reducer,
  roles: rolesSlice.reducer,
  permissions: permissionsSlice.reducer,
  users: usersSlice.reducer,
  companies: companiesSlice.reducer,
  leads: leadsSlice.reducer,
  deals: dealsSlice.reducer,
  activitylogs: activitylogsSlice.reducer,
  systemSettings: settingsSlice.reducer,
  announcements: announcementSlice.reducer,
  banks: banksSlice.reducer,
  clients: clientsSlice.reducer,
  bankProducts: bankProductsSlice.reducer,
  bankUpdates: bankUpdatesSlice.reducer,
  eibors: eiborSLice.reducer,
  proposalFee: feeProposalSLice.reducer,
  bankRates: bankRates.reducer,
  proposalRequiredDocs: requiredDocsProposalSLice.reducer,
  proposals: proposalSlice.reducer,
});

const middlewareOption = {
  immutableCheck: false,
  serializableCheck: false,
  thunk: true,
};

const store = configureStore({
  reducer: (state, action) => {
    if (action.type === "auth/logout") {
      state = undefined;
    }
    return reducer(state, action);
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware(middlewareOption).concat(progressMiddleware),
  devTools: process.env.REACT_APP_DEV_TOOLS === "true", // Hide redux in production
});

export default store;
